<template>
  <div>
    <arhslgl-base-header-sec
      title="Архива службеног листа"
      slug="slarh"
      class="mb-0"
    ></arhslgl-base-header-sec>

    <section
      v-if="numberData"
      class="number-overview-header-sec base-header-sec-2 base-header-laen  laen"
    >
      <div class="container-fluid">
        <div class=" container-lg  base-header__container ">
          <div
            class="inner ml-lg-5 d-flex justify-content-between align-items-center"
          >
            <div class="">
              {{ numberData.issueType }} {{ numberData.num }}/{{
                numberData.year
              }}
              | Датум: {{ numberData.publishDateStr }} | PDF
              <router-link
                v-if="canOpen === 'can_open'"
                :to="'/slglrsViewPdf/' + numberData.id"
                replace
                class="ml-2"
                target="_blank"
                @mousedown.native="isInternal && clickOnInternal($event)"
              >
                <span class="icon-file-pdf-o" style="color: #e14356"></span
              ></router-link>

              <a
                v-if="canOpen === 'not_logged_in'"
                class="ml-2"
                v-b-modal.login-modal
                href="#"
                @click.stop.prevent
              >
                <span class="icon-file-pdf-o" style="color: #e14356"></span>
              </a>
              <a
                v-if="canOpen === 'role_not_allowed'"
                href="#"
                class="ml-2"
                @click.stop.prevent="role_not_allowed()"
              >
                <span class="icon-file-pdf-o" style="color: #e14356"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--        sgarh-->
    <!--        slarh-->
    <!--        pgarh-->
    <!--        muarh-->

    <div class="container-fluid base-container ">
      <div class=" accordion flex-fill" role="tablist">
        <div v-if="laws">
          <b-card no-body class="ac_card">
            <b-card-header
              header-tag="header"
              class="ac_card-header"
              role="tab"
            >
              <b-button
                class="btn btn-block accordion-title-btn text-uppercase"
                variant="none"
                block
                href="#"
                v-b-toggle="'accordion-low'"
              >
                ЗАКОНИ, ДРУГИ ПРОПИСИ, ОПШТИ И ПОЈЕДИНАЧНИ АКТИ
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-low"
              :visible="true"
              class="ac_collapse scroll_to_collapse"
              role="tabpanel"
            >
              <b-card
                no-body
                v-for="item in laws"
                v-bind:key="item.docGroupId"
                class="ac_card"
                >
                <b-card-header
                header-tag="header"
                class="ac_card-header"
                role="tab"
                v-if="item.docGroupId !== null"
                >
                  <b-button
                    class="btn btn-block accordion-title-btn-level-2"
                    variant="none"
                    block
                    href="#"
                    v-b-toggle="'accordion-' + item.docGroupId"
                  >
                    {{ item.docGroupName }}
                  </b-button>
                </b-card-header>
                <b-collapse
                  :id="'accordion-' + item.docGroupId"
                  :visible="true"
                  class="ac_collapse scroll_to_collapse"
                  role="tabpanel"
                >
                  <ul class="ac_collapse__item-list-level-2">
                    <li
                      class="ac_collapse__item"
                      v-for="sub_item in item.items"
                      v-bind:key="sub_item.id"
                    >
                      <div>
                        <router-link
                          v-if="canOpen === 'can_open'"
                          target="_blank"
                          class="ac_collapse__link-level-2 accordion-item-link "
                          :to="{ path: getRouterLink(sub_item) }"
                          @mousedown.native="isInternal && clickOnInternal($event)"
                          >{{ sub_item.name }}</router-link
                        >
                      </div>
                      <a
                        class="ac_collapse__link-level-2 accordion-item-link "
                        v-if="canOpen === 'not_logged_in'"
                        v-b-modal.login-modal
                        href="#"
                        @click.stop.prevent
                      >
                        {{ sub_item.name }}
                      </a>
                      <a
                        class="ac_collapse__link-level-2 accordion-item-link "
                        v-if="canOpen === 'role_not_allowed'"
                        href="#"
                        @click.stop.prevent="role_not_allowed()"
                      >
                        {{ sub_item.name }}
                      </a>
                    </li>
                  </ul>
                </b-collapse>
              </b-card>
            </b-collapse>
          </b-card>
        </div>

        <div v-if="ads">
          <b-card no-body class="ac_card">
            <b-card-header
              header-tag="header"
              class="ac_card-header"
              role="tab"
            >
              <b-button
                class="btn btn-block accordion-title-btn text-uppercase"
                variant="none"
                block
                href="#"
                v-b-toggle="'accordion-adds'"
              >
                ОГЛАСИ
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-adds"
              :visible="false"
              class="ac_collapse scroll_to_collapse"
              role="tabpanel"
            >
              <b-card
                no-body
                v-for="item in ads"
                v-bind:key="item.docGroupId"
                class="ac_card"
              >
                <b-card-header
                  header-tag="header"
                  class="ac_card-header"
                  role="tab"
                >
                  <b-button
                    class="btn btn-block accordion-title-btn-level-2 btn-none collapsed"
                    variant="none"
                    block
                    href="#"
                    v-b-toggle="'accordion-' + item.docGroupId"
                  >
                    {{ item.docGroupName }}
                  </b-button>
                </b-card-header>
                <b-collapse
                  :id="'accordion-' + item.docGroupId"
                  class="ac_collapse scroll_to_collapse"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <ul class="ac_collapse__item-list-level-2 ">
                    <li
                      class="ac_collapse__item"
                      v-for="sub_item in item.items"
                      v-bind:key="sub_item.id"
                    >
                      <div v-if="sub_item.subDocGroupId" class="">
                        <a
                          class="ac_collapse__link-level-2 accordion-item-link"
                          v-b-toggle="'accordion-' + sub_item.subDocGroupId"
                        >
                          <span>{{ sub_item.subDocGroupName }}</span>
                        </a>
                        <b-collapse
                          :id="'accordion-' + sub_item.subDocGroupId"
                          class="ac_collapse scroll_to_collapse"
                          :accordion="'accordion-' + item.docGroupId"
                          role="tabpanel"
                        >
                          <ul class="ac_collapse__item-list-level-2">
                            <li
                              class="ac_collapse__item"
                              v-for="sub_sub_item in sub_item.subItems"
                              v-bind:key="sub_sub_item.id"
                            >
                              <!--                                                            {{sub_item}}-->
                              <div>
                                <router-link
                                  v-if="canOpen === 'can_open'"
                                  target="_blank"
                                  class="ac_collapse__link-level-3 accordion-item-link "
                                  :to="{ path: getRouterLink(sub_sub_item) }"
                                  @mousedown.native="isInternal && clickOnInternal($event)"
                                  >{{ sub_sub_item.name }}</router-link
                                >
                              </div>
                              <a
                                class="ac_collapse__link-level-3 accordion-item-link "
                                v-if="canOpen === 'not_logged_in'"
                                v-b-modal.login-modal
                                href="#"
                                @click.stop.prevent
                              >
                                {{ sub_sub_item.name }}
                              </a>
                              <a
                                class="ac_collapse__link-level-3 accordion-item-link "
                                v-if="canOpen === 'role_not_allowed'"
                                href="#"
                                @click.stop.prevent="role_not_allowed()"
                              >
                                {{ sub_sub_item.name }}
                              </a>
                            </li>
                          </ul>
                        </b-collapse>
                      </div>
                      <div v-else>
                        <div>
                          <router-link
                            v-if="canOpen === 'can_open'"
                            target="_blank"
                            class="ac_collapse__link-level-2 accordion-item-link "
                            :to="{ path: getRouterLink(sub_item) }"
                            @mousedown.native="isInternal && clickOnInternal($event)"
                            >{{ sub_item.name }}</router-link
                          >
                        </div>
                        <a
                          class="ac_collapse__link-level-2 accordion-item-link "
                          v-if="canOpen === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ sub_item.name }}
                        </a>
                        <a
                          class="ac_collapse__link-level-2 accordion-item-link "
                          v-if="canOpen === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ sub_item.name }}
                        </a>
                      </div>
                    </li>
                  </ul>
                </b-collapse>
              </b-card>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
    <div class="spacer50"></div>
  </div>
</template>

<script>
import axios from "axios";
import ArhslglBaseHeaderSec from "@/base_pages/arhslgl/ArhslglBaseHeaderSec.vue";
import { mapState } from "vuex";


export default {
  name: "SlarhNumberOverviewPage",
  data() {
    return {
      ads: null,
      laws: null,
      pageData: null,
      numberData: null,
      baseApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      baseUrl: window.location.origin,
      isInternal: false,
      activeElement: null,
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords },
      ],
    };
  },
  components: {
    ArhslglBaseHeaderSec,
  },
  computed: {
    ...mapState(["userInfoState"]),
    canOpen() {
      if (this.userInfoState) {
        if (this.userInfoState.roles.includes("SLARHSTARO")) {
          return "can_open";
        } else {
          return "role_not_allowed";
        }
      } else {
        return "not_logged_in";
      }
    },
  },
  methods: {
    role_not_allowed() {
      alert("Немате приступ овој бази");
    },
    clickOnInternal(event) {
      // ako treba da bude crven samo zadnje kliknut
      //   if (this.activeElement) {
      //     this.activeElement.style.color = "";
      //   }
      if (event.button === 0 || event.button === 1){
        this.activeElement = event.target;
        this.activeElement.style.color = "red";
      }
    },
    fetchData() {
      const actionName =
        this.$route.query.internal === "true"
          ? "Prins/arhslgl/internaloverview/number?numberId="
          : "prins/arhslgl/overview/number?numberId=";
      axios
        .get(this.baseApiUrl + actionName + this.$route.params.actId)
        .then((response) => {
          this.pageData = response.data;
          this.ads = response.data.ads;
          this.laws = response.data.laws;
          console.log(this.pageData);
        })
        .catch((error) => {
          if (error.response.status === 404) {
            window.location.href = "/";
          }
        });
    },
    fetchNumber() {
      axios
        .get(this.baseApiUrl + "prins/number/find/" + this.$route.params.actId)
        .then((response) => {
          this.numberData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRouterLink(item) {
      return item.url != null
        ? `/slglrs/viewAct/${item.id}?internal=${this.isInternal}`
        : `/slglrsViewPdf/${item.ogNumberId}?internal=${this.isInternal}`;
    },
  },
  mounted() {
    if (this.$route.query.internal === "true") this.isInternal = true;
    this.fetchData();
    this.fetchNumber();
  },
  beforeCreate: function() {
    document.body.className = "color_arhslgl";
  },
};
</script>

<style scoped>
.accordion .card .card-header .btn {
  padding: 12px 70px 12px 30px !important;
}

.btn:after {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
</style>
